import { render } from "./Table.vue?vue&type=template&id=5fac5f02"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fac5f02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fac5f02', __exports__)) {
    api.reload('5fac5f02', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=5fac5f02", () => {
    api.rerender('5fac5f02', render)
  })

}


export default __exports__